import axios from "axios";
import { authHeader } from "../_helpers";

export const organisationService = {
  updateMandateGroupAction,
  groupReportPDFService,
  groupReportListService,
  competencyMetricPrefillService,
  getAttributeService,
  getCompetencyService,
  getIntrumentListFull,
  getOrgData,
  addOrgData,
  delOrgData,
  editOrgData,
  adminOrgData,
  makeAdminOrgData,
  removeAdminOrgData,
  deleteAdminOrgData,
  getBatchData,
  getBatchDetails,
  getOrganizationMandate,
  addBatch,
  deleteBatch,
  getAllotedUnallotedList,
  updateMinimumRespondance,
  getParticipent,
  addParticipants,
  enablePI,
  disablePI,
  allotBatches,
  removeFromBatch,
  setExpiryDate,
  unsubmittedAssessment,
  resetAssessmentService,
  enableReports,
  disableReports,
  deleteReports,
  setReportTheme,
  getThemeReport,
  getInstrumentList,
  allotAssessmentParticipant,
  setDevPlan,
  editRelation,
  getCustomReportService,
  setReportCustomService,
  batchPermAdminOrgData,
  addAnalyticsService,
  removeAnalyticsService,
  sellOrgCreditService,
  revokeOrgCreditService,
  getManageMetricHandler,
  addManageMetricHandler,
  deleteManageMetricHandler,

  UploadAssessmentActionService,
  UploadRespondentActionService,
  UploadAssessmentResponsesActionService,
  UploadAssessmentResponsesResultListActionService,
  UploadAssessmentResponsesResultViewActionService,


  demographicDownload,

  groupReportAssesorList,
  groupReportInstrumentList,

  //role fitment report services
  getHolderAndOrganisationCompetency,
  getOrganisationFitments,
  getOrganisationFitmentsList,
  createOrganisationFitments,
  updateOrganisationFitments,
  getAllotedOrganisationFitments,
  deleteOrganisationFitments

}

axios.defaults.headers.common = authHeader();

let token = localStorage.getItem("access_token");



function groupReportAssesorList(data) {
  token = localStorage.getItem("access_token");

  return axios
    .post(
      `/assessments/group/report/assessor/group/list/?access_token=${token}`,
      data
    )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function groupReportInstrumentList() {
  token = localStorage.getItem("access_token");

  return axios
    .get(`/assessments/group/report/instrument/list/?access_token=${token}`)
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function demographicDownload(data) {
  return axios
    .post(`/masters/download/demographic/data/?access_token=${token}`, data)
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function updateMandateGroupAction(data) {
  return axios
    .post(
      `/assessments/organisation/batch/update/mandate/group/${data.batchId}/?access_token=${token}`,
      data.data
    )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function groupReportPDFService(data) {
  return axios
    .post(`/assessments/group/report/pdf/data/?access_token=${token}`, data)
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function groupReportListService(data) {
  return axios
    .post(
      `/assessments/group/report/organisation/assessments/?access_token=${token}`,
      data
    )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function UploadRespondentActionService(data) {
  let token = localStorage.getItem("access_token");

  return axios
    .post(`/users/upload/respondets/assessment/?access_token=${token}`, data)
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function UploadAssessmentActionService(data) {
  let token = localStorage.getItem("access_token");

  return axios
    .post(`/users/upload/assessment/?access_token=${token}`, data)
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function UploadAssessmentResponsesActionService(data) {

  let token = localStorage.getItem('access_token')

  return axios.post(`assessments/bulk/bg/submit-response`, data)
    .then(handleResponse)
    .then(response => {
      return response
    })
}

function UploadAssessmentResponsesResultListActionService(orgId, instrumentId) {
  return axios.get(`assessments/bulk/bg/submit-respons/result?organisation=${orgId}&instrument=${instrumentId}`)
    .then(handleResponse)
    .then(response => {
      return response
    })
}

function UploadAssessmentResponsesResultViewActionService(data, orgId, instrumentId) {
  return axios.post(`assessments/bulk/bg/submit-respons/result?organisation=${orgId}&instrument=${instrumentId}`, data)
    .then(handleResponse)
    .then(response => {
      return response
    })
}


function competencyMetricPrefillService() {
  return axios
    .get("/users/default/competency/metric/list/?access_token=${token}")
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function getAttributeService() {
  return axios
    .get("/users/attribute/list/?access_token=${token}")
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function getCompetencyService() {
  return axios
    .get("/users/competency/type/list/?access_token=${token}")
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function getIntrumentListFull() {
  return axios
    .get("/masters/instrument/list/?access_token=${token}")
    .then(handleResponse)
    .then((response) => {

      return response;
    });
}

function getOrgData() {
  let token = localStorage.getItem("access_token");

  return axios
    .get(`/users/organisation/create/list/?access_token=${token}`)
    .then(handleResponse)
    .then((response) => {
      response.data.organisation_list[0]
        ? localStorage.setItem(
          "seller_id_new",
          response.data.organisation_list[0].seller__id
        )
        : null;
      return response;
    });
}

function addOrgData(data) {
  return axios
    .post("/users/organisation/create/list/?access_token=${token}", data)
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function delOrgData(data) {
  return axios
    .post("/users/organisation/delete/?access_token=${token}", data)
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function editOrgData(data) {
  data.constructData["seller"] = data.id;
  data.constructData.country !== null
    ? parseInt(data.constructData.country, 10)
    : null;

  return axios
    .put(
      `/users/organisation/update/${data.orgId}/?access_token=${token}`,
      data.constructData
    )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function adminOrgData(data) {
  return axios
    .post(`/users/organisation/add/admin/?access_token=${token}`, data)
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function makeAdminOrgData(data) {

  return axios
    .post(`/users/make/organisation/primary/admin/?access_token=${token}`, data)
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function removeAdminOrgData(data) {
  return axios
    .post(`/users/organisation/remove/admin/?access_token=${token}`, data.data)
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function deleteAdminOrgData(data) {
  return axios
    .post(`/users/organisation/delete/admin/user/?access_token=${token}`, data.data)
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}



function getBatchData(data) {
  return axios
    .get(
      `/assessments/organisation/batch/add/list/${data.sellerId}/${data.orgId}/?access_token=${token}`
    )
    .then(handleResponse)
    .then((response) => {

      return response;
    });
}

//Get organization_group_mandate

function getOrganizationMandate(data) {

  if (data !== null && data !== '' && data !== undefined) {
    return axios.get(`/users/organisation/assessor/group/list/edit/${data.sellerId}/${data.orgId}/?access_token=${token}`)
      .then(handleResponse)
      .then(response => {

        return response
      })
  }

}

function addBatch(data) {

  return axios
    .post(
      `/assessments/organisation/batch/add/list/${data.sellerId}/${data.orgId}/?access_token=${token}`,
      data.data
    )
    .then(handleResponse)
    .then((response) => {

      return response;
    });
}

function deleteBatch(data) {
  return axios
    .post(
      `/assessments/organisation/batch/delete/?access_token=${token}`,
      data.data
    )
    .then(handleResponse)
    .then((response) => {

      return response;
    });
}

function getBatchDetails(orgId, batchId) {
  return axios
    .get(
      `/assessments/organisation/batch/detail/view/${orgId}/${batchId}/?access_token=${token}`
    )
    .then(handleResponse)
    .then((response) => {

      return response;
    });
}

function getAllotedUnallotedList(data) {

  return axios
    .post(
      `/assessments/organisation/batch/assessment/?access_token=${token}`,
      data.data
    )
    .then(handleResponse)
    .then((response) => {

      return response;
    });
}

function updateMinimumRespondance(data) {

  return axios
    .post(
      `/assessments/organisation/batch/update/minimum/respondence/${data.linkId}/?access_token=${token}`,
      data.data
    )
    .then(handleResponse)
    .then((response) => {

      return response;
    });
}

//Manage participants
function getParticipent(data) {
  return axios
    .get(
      `/users/organisation/participant/list/${data.sellerId}/${data.orgId}/?access_token=${token}`
    )
    .then(handleResponse)
    .then((response) => {

      return response;
    });
}

function getInstrumentList(data) {

  return axios
    .get(
      `/users/organisation/assessment/credit/list/${data.sellerId}/${data.orgId}/?access_token=${token}`
    )
    .then(handleResponse)
    .then((response) => {

      return response;
    });
}

function addParticipants(data) {

  return axios
    .post(
      `/users/organisation/add/paricipants/bulk/${data.sellerId}/${data.orgId}/?access_token=${token}`,
      data.data
    )
    .then(handleResponse)
    .then((response) => {

      return response;
    });
}

function allotAssessmentParticipant(data) {
  return axios
    .post(
      `/assessments/allot/assessment/user/bulk/?access_token=${token}`,
      data
    )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function enablePI(data) {
  return axios
    .post(
      `/users/enable/pi/bulk/${data.sellerId}/${data.orgId}/?access_token=${token}`,
      data.data
    )
    .then(handleResponse)
    .then((response) => {

      return response;
    });
}

function disablePI(data) {
  return axios
    .post(
      `/users/disable/pi/bulk/${data.sellerId}/${data.orgId}/?access_token=${token}`,
      data.data
    )
    .then(handleResponse)
    .then((response) => {

      return response;
    });
}

//Manage Batches unalloted modal Api's
function allotBatches(data) {
  return axios
    .post(
      `/assessments/organisation/allot/user/to/batch/bulk/${data.sellerId}/${data.orgId}/${data.batchId}/?access_token=${token}`,
      data.data
    )
    .then(handleResponse)
    .then((response) => {

      return response;
    });
}

function removeFromBatch(data) {
  return axios
    .post(
      `/assessments/organisation/remove/user/from/batch/bulk/${data.sellerId}/${data.orgId}/${data.batchId}/?access_token=${token}`,
      data.data
    )
    .then(handleResponse)
    .then((response) => {

      return response;
    });
}

function setExpiryDate(data) {
  return axios
    .post(
      `/assessments/change/expiry/date/bulk/?access_token=${token}`,
      data.data
    )
    .then(handleResponse)
    .then((response) => {

      return response;
    });
}

function disableReports(data) {
  return axios
    .post(`/assessments/disable/reports/bulk/?access_token=${token}`, data.data)
    .then(handleResponse)
    .then((response) => {

      return response;
    });
}

function enableReports(data) {
  return axios
    .post(`/assessments/enable/reports/bulk/?access_token=${token}`, data.data)
    .then(handleResponse)
    .then((response) => {

      return response;
    });
}

function getThemeReport() {
  return axios
    .get(`/masters/report/theme/list/?access_token=${token}`)
    .then(handleResponse)
    .then((response) => {

      return response;
    });
}

function setReportTheme(data) {
  return axios
    .post(`/masters/set/report/theme/bulk/?access_token=${token}`, data.data)
    .then(handleResponse)
    .then((response) => {

      return response;
    });
}

function unsubmittedAssessment(data) {
  return axios
    .post(
      `/assessments/unsubmitted/assessments/bulk/?access_token=${token}`,
      data.data
    )
    .then(handleResponse)
    .then((response) => {

      return response;
    });
}

function resetAssessmentService(data) {
  return axios
    .post(
      `/assessments/assessments/reset/?access_token=${token}`,  
      data
    )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}




function deleteReports(data) {

  return axios
    .post(`/assessments/delete/assessments/?access_token=${token}`, data.data)
    .then(handleResponse)
    .then((response) => {

      return response;
    });
}

function setDevPlan(data) {

  return axios
    .post(`/assessments/set/development/plan/bulk/?access_token=${token}`, data)
    .then(handleResponse)
    .then((response) => {

      return response;
    });
}

function getCustomReportService() {
  let token = localStorage.getItem("access_token");

  return axios
    .get(`/masters/relation/group/list/create/?access_token=${token}`)
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function setReportCustomService(data) {
  return axios
    .post(
      `/assessments/set/remove/custom/reports/access/bulk/?access_token=${token}`,
      data
    )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function batchPermAdminOrgData(data) {
  return axios
    .post(
      `/assessments/organisation/batch/permission/${data.sellerId}/${data.orgId}/?access_token=${token}`,
      data.data
    )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function addAnalyticsService(data) {
  return axios
    .post(
      `/assessments/enable/indivisual/analytics/?access_token=${token}`,
      data
    )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function removeAnalyticsService(data) {
  return axios
    .post(
      `/assessments/disable/indivisual/analytics/?access_token=${token}`,
      data
    )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function sellOrgCreditService(data) {
  return axios
    .post(
      `/users/organisation/assessment/sell/credit/?access_token=${token}`,
      data
    )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function revokeOrgCreditService(data) {
  return axios
    .post(
      `/users/organisation/assessment/revoke/credit/?access_token=${token}`,
      data
    )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

function handleResponse(response) {
  if (response.status === 200) {
    if (response.organisation_list) {
      if (response.organisation_list.length == 0) {
        const error = "No data to display";
        return Promise.reject(error);
      }
      return response;
    }
    return response;
  } else if (response.status === 201) {
    return response;
  } else if (response.status === 400) {
    const error404 = "No data to display";
    return Promise.reject(error404);
  }
  return response;
}

function editRelation(selId, orgId, data) {
  return axios
    .post(
      `/users/organisation/assessor/group/list/edit/` +
      selId +
      `/` +
      orgId +
      `/`,
      data
    )
    .then((response) => {
      return response;
    });
}

function getManageMetricHandler(org_id, comp_id) {
  return axios
    .get(
      `/users/organisation/competency/metric/create/list/update/${org_id}/${comp_id}/`
    )
    .then((response) => {
      return response;
    });
}

function addManageMetricHandler(orgId, compId, data) {
  return axios
    .post(
      `/users/organisation/competency/metric/create/list/update/` +
      orgId +
      `/` +
      compId +
      `/`,
      data
    )
    .then((response) => {
      return response;
    });
}

function addManageMetricHandler(orgId, compId, data) {
  return axios
    .post(
      `/users/organisation/competency/metric/create/list/update/` +
      orgId +
      `/` +
      compId +
      `/`,
      data
    )
    .then((response) => {
      return response;
    });
}

function deleteManageMetricHandler(orgId, compId) {
  const data = {
    organisation: orgId,
    competency_id: compId,
  };
  return axios
    .post(`/users/organisation/competency/metric/delete/`, data)
    .then((response) => {
      return response;
    });
}

//holder list api
function getHolderAndOrganisationCompetency({ orgId }) {
  return axios.get(`users/holder/list/${orgId}/`).then((response) => {
    return response;
  });
}

//get organisation fitments
function getOrganisationFitments({ orgId, fitment_id }) {
  return axios
    .get(`users/holder/list/${orgId}/${fitment_id}/`)
    .then((response) => {
      return response;
    });
}

//get organisation fitments
function getOrganisationFitmentsList({ orgId }) {
  return axios
    .get(`users/organisation/fitment/create/list/${orgId}/0/`)
    .then((response) => {
      return response;
    });
}

//create organisation fitments
function createOrganisationFitments({ orgId, requestObject }) {
  return axios
    .post(`users/organisation/fitment/create/list/${orgId}/0/`, requestObject)
    .then((response) => {
      return response;
    });
}

//update organisation fitments
function updateOrganisationFitments({ orgId, fitment_id, requestObject }) {
  
  return axios
    .post(
      `users/organisation/fitment/create/list/${orgId}/${fitment_id}/`,
      requestObject
    )
    .then((response) => {
      return response;
    });
}

//delete organisation fitments
function deleteOrganisationFitments({ orgId, fitment_id, requestObject }) {
  return axios
    .post(`users/organisation/fitment/delete/${orgId}/`, requestObject)
    .then((response) => {
      return response;
    });
}

//get organisation fitments
function getAllotedOrganisationFitments({ orgId }) {
  return axios
    .get(`analytics/organisation/fitment_list/${orgId}/`)
    .then((response) => {
      return response;
    });
}



// WEBPACK FOOTER //
// ./src/_services/organisation.service.js